import Button from "Components/shared/button";
import FormControl from "Components/shared/control";
import { InputWithAdornment } from "Components/shared/inputs";
import Modal from "Components/shared/modal";
import Select from "Components/shared/select";
import React from "react";
import styles from "../account/account.module.css";

export const RequestNewCardModal = ({
  openModal,
  handleComplete,
  setOpenModal,
  loading,
  requestCard
}) => {
  return (
    <Modal
      open={openModal}
      onClose={() => setOpenModal(false)}
      disableBackdropClick
      heading={"Request New card"}
    >
      <div className={styles.addBankFormat}>
        <div>
          <FormControl
            fullWidth
            label="Reason for new card"
            style={{ width: "100%", padding: 0 }}
          >
            <Select
              options={["My Card was stolen", "Expired", "New User"]}
              placeholder="Choose Reason"
              fullWidth
            />
          </FormControl>
        </div>
      </div>

      <div
        className="row-start"
        style={{
          gap: "1rem",

          marginTop: "2rem",
        }}
      >
        <div className={styles.flexButton}>
          <Button
            label="Request new card"
            className={(styles.button, styles.cancle)}
            onClick={requestCard}
            loading={loading}
          />
        </div>
      </div>
    </Modal>
  );
};
